module.exports = __webpack_public_path__ + "static/media/34.03fe1aaf.mp4";